"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUnitIDFromUser = exports.getUserStorageKey = exports.normalizeUser = void 0;
const Hashing_1 = require("./Hashing");
function normalizeUser(original, environment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (environment != null) {
            copy.statsigEnvironment = environment;
        }
        return copy;
    }
    catch (error) {
        throw new Error('User object must be convertable to JSON string.');
    }
}
exports.normalizeUser = normalizeUser;
function getUserStorageKey(sdkKey, user) {
    return (0, Hashing_1.DJB2Object)({ sdkKey, user });
}
exports.getUserStorageKey = getUserStorageKey;
function getUnitIDFromUser(user, idType) {
    var _a, _b, _c;
    if (typeof idType === 'string' && idType.toLowerCase() !== 'userid') {
        return (_b = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a[idType]) !== null && _b !== void 0 ? _b : (_c = user === null || user === void 0 ? void 0 : user.customIDs) === null || _c === void 0 ? void 0 : _c[idType.toLowerCase()];
    }
    return user.userID;
}
exports.getUnitIDFromUser = getUnitIDFromUser;
